@if (isLoaded) {
  <div class='producer-telesales-content-filter'>
    @if (isAuthoring) {
      <div>Producer Only Content</div>
    }
    @if (!isTelesales || isAuthoring) {
      <slot name="producer-slot"></slot>
    }
    @if (isAuthoring) {
      <div>Telesales Only Content</div>
    }
    @if (isTelesales || isAuthoring) {
      <slot name="telesales-slot"></slot>
    }
  </div>
}